export default __webpack_public_path__ + "static/media/Green0001.0b7ceb69.png";